import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import heroImage from './assets/hero-mtb.jpg';
import SiteNav from './components/SiteNav';

// Import pages
import RegisterPage from './pages/Register';
import LoginPage from './pages/Login';
import ProfilePage from './pages/Profile';
import AddMinorPage from './pages/AddMinor';
import DashboardPage from './pages/Dashboard';
import EventsPage from './pages/Events';
import EventDetailsPage from './pages/EventDetails';
import CategoryGuidePage from './pages/CategoryGuide';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PaymentNotify from './pages/PaymentNotify';
import CoordinatorEventManagement from './pages/CoordinatorEventManagement';
import AdminManagement from './pages/AdminManagement';
import CoordinatorUpgradeSuccess from './pages/CoordinatorUpgradeSuccess';
import CoordinatorUpgradeCancel from './pages/CoordinatorUpgradeCancel';

import Alerts from './pages/Alerts';
import AdminNotifications from './pages/AdminNotifications';
import PayfastTest from './pages/PayfastTest';
import PayFastCheckout from './pages/PayFastCheckout';


// Pages
const Home = () => (
  <div className="min-h-screen">
    {/* Hero Section */}
    <div className="relative h-96 bg-gradient-to-r from-orange-600 to-orange-800">
      <div className="absolute inset-0">
        <img 
          className="w-full h-full object-cover opacity-90" 
          src={heroImage}
          alt="Mountain Bike Action" 
          onError={(e) => {
            // Hide image if it fails to load, showing the orange gradient background
            e.currentTarget.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gray-900 opacity-50"></div>
      </div>
      <div className="relative content-container py-24 sm:py-32">
        <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
          GOMTB Register
        </h1>
        <p className="mt-6 text-xl text-gray-300 max-w-3xl">
          Join the ultimate mountain biking community. Register for events, compete with riders, and experience the thrill of the trails.
        </p>
        <div className="mt-10">
          <Link 
            to="/events" 
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-orange-600 transition duration-300"
          >
            View Upcoming Events
          </Link>
        </div>
      </div>
    </div>

    {/* Content Section */}
    <div className="py-12 content-container">
      <div>
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Get Started</h2>
          <p className="text-lg text-gray-600">
            Choose your path to mountain biking excellence
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Register for Events</h2>
              <p className="text-gray-600 mb-4">Sign up for upcoming mountain bike events and competitions.</p>
              <Link to="/register" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-orange-600 transition duration-300">
                Register Now
              </Link>
            </div>
          </div>
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Browse Events</h2>
              <p className="text-gray-600 mb-4">Explore upcoming and past mountain bike events in your area.</p>
              <Link to="/events" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-orange-600 transition duration-300">
                View Events
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <SiteNav />

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:eventId" element={<EventDetailsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/add-minor" element={<AddMinorPage />} />
            <Route path="/categories" element={<CategoryGuidePage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/payment/notify" element={<PaymentNotify />} />
            <Route path="/coordinator/events" element={<CoordinatorEventManagement />} />
            <Route path="/admin" element={<AdminManagement />} />
            <Route path="/admin/users" element={<AdminManagement />} />
            <Route path="/admin/events" element={<AdminManagement />} />
            <Route path="/admin/coordinators" element={<AdminManagement />} />
            <Route path="/coordinator-upgrade-success" element={<CoordinatorUpgradeSuccess />} />
            <Route path="/coordinator-upgrade-cancel" element={<CoordinatorUpgradeCancel />} />

            <Route path="/dashboard/alerts" element={<Alerts />} />
            <Route path="/admin/notifications" element={<AdminNotifications />} />
            <Route path="/payfast-test" element={<PayfastTest />} />
            <Route path="/payfast-checkout" element={<PayFastCheckout />} />

          </Routes>
        </main>

        <footer className="app-site-footer">
          <div className="py-6 px-4 sm:px-6 lg:px-8">
            <p className="text-center text-sm">
              &copy; {new Date().getFullYear()} GOMTB Register. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
